import { AddFluxHOCProps, addFlux } from 'components/wrappers/WithFlux';
import { Filters } from 'model/Filters';
import { PureComponent } from 'react';

import { STATUS_PENDING } from '../../constants';

interface MoreFiltersAmountOfResultsProviderProps {
  filters: Filters;
  children: (state: MoreFiltersAmountOfResultsProviderState) => any;
}

interface MoreFiltersAmountOfResultsProviderState {
  amountOfResults: number;
  isLoading: boolean;
}

class MoreFiltersAmountOfResultsProvider extends PureComponent<
  MoreFiltersAmountOfResultsProviderProps & AddFluxHOCProps,
  MoreFiltersAmountOfResultsProviderState
> {
  state = this.getStateFromStore();

  componentDidMount() {
    this.props.flux.stores.SearchStore.on('change', this.onStoreChange);
  }

  componentWillUnmount() {
    this.props.flux.stores.SearchStore.removeListener(
      'change',
      this.onStoreChange,
    );
  }

  onStoreChange = () => {
    this.setState(this.getStateFromStore());
  };

  getStateFromStore() {
    const { SearchStore } = this.props.flux.stores;
    const searchResults = SearchStore.getSearchResult(this.props.filters);

    return {
      amountOfResults: searchResults?.maxResults ?? 0,
      isLoading:
        (searchResults?.pages?.[0]?.status ?? STATUS_PENDING) ===
        STATUS_PENDING,
    };
  }

  render() {
    return this.props.children(this.state);
  }
}

export default addFlux(MoreFiltersAmountOfResultsProvider);
